import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ActivityType } from '../activity-type';

export class ActivityTypeBuilder {
  static fromJson(json) {
    return (json)
      ? new ActivityType(
        parseNumber(json.code),
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ActivityTypeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/activity-type.builder.ts